import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTIES_LIST = {
  'list': [],
  'loading': false,
  'agencyList': [],
};

const INITIAL_STATE_WARRANTIES_AGENCY = {
  'agencyList': [],
};

export const warrantiesList = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_LIST, {
    [ActionTypes.FETCHING_TWC_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};


const INITIAL_STATE_WARRANTIES_STATUS = {
  'list': [],
  'loading': false,
};

export const warrantiesStatus = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_STATUS, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_STATUS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_STATUS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};


const INITIAL_STATE_WARRANTY = {
  'warranty': null,
  'loading': false,
};

export const warranty = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
    [ActionTypes.CLEAR_WARRANTY]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
  })(state, action);
};

export const getWarrantyAgency = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_AGENCY, {
    [ActionTypes.FETCHING_TWC_AGENCIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_AGENCIES]: (state, action) => ({
      ...state,
      'loading': false,
      'agencyList': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_AGENCIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'agencyList': [],
    }),
  })(state, action);
};
